/**
 * Position des FieldsSet dans les parametrages des rapports
 */
export enum EnumLayout {
    Column = 1,
    Row = 2
}